/* eslint-disable camelcase */
/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Loader, useModal } from '@jutro/components';
import CustomLoader from 'producer-engage/src/components/CustomLoader/CustomLoader';
import { TranslatorContext } from '@jutro/locale';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';
import React, { useCallback, useContext,useState, useEffect } from 'react';
// import StandardizeAddressPopUp from 'ent-capability-quoteandbind-common-react/components/StandardizeAddressPopUp/StandardizeAddressPopUp';
import { TWIAPhoneComponent, TWIAAddressComponent, TWIAEmailComponent } from 'twia-capability-address-component';
import addressControl from 'twia-capability-address-component/util/addressControl';
import { GatewayRenewalService as RenewalService } from 'gw-capability-gateway-policyrenewal';
// import PrintDocumentUtil from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtil.js';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils.js';
import PrintDocumentConfirmationPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentErrorPopup';
import { PolicyDiffComponent } from "gw-capability-policyjob-react/index.js";
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import StandardAddressValidationUtil from 'twia-capability-address-component/util/StandardAddressValidationUtil';
import { GatewayEndorsementService } from '../../../../capabilities/twia-capability-gateway-policychange';
import metadata from './CoverageSummaryPage.metadata.json5';
import styles from './CoverageSummaryPage.module.scss';
import AddressStandardizationService from '../../../../../common/capabilities/twia-capability-addressstandaradization/services/AddressStandardizationService';


function TWIACoverageSummaryPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const { wizardData: submissionVM, updateWizardData, onResolve, onAfterClose } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [accountHolderVM, setAccountHolderVM] = useState(submissionVM.baseData.accountHolder);
    const [addressVM, setAddressVM] = useState(submissionVM.baseData.accountHolder.primaryAddress);
    const [addressVMPolicy, setAddressVMPolicy] = useState(submissionVM.baseData.policyAddress);
    const { showAlert, showConfirm, showModal } = useModal();
    const [showErrors, setShowErrors] = useState(false);
    const { authHeader } = useAuthentication();
    const country = _.get(accountHolderVM, 'primaryAddress.country.value.code');
    const isPerson = _.get(submissionVM, 'baseData.accountHolder.subtype.value') === 'Person';
    const [invalidComponent, setInvalidComponents] = useState([]);
    const { isComponentValid, initialValidation, onValidate } = useValidation('TWIACoverageSummaryPage');
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [ pcConstants, setPCConstants ] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [ isAddressEdited, setIsAddressEdited ] = useState(false);
    const [validatingEmail, setValidatingEmail] = useState(false);
    const xPortal = 'PE';
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal';
    const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);
    const jobID = _.get(submissionVM, 'jobID.value');
    const selectedUWCompany = isRenewal ? _.get(submissionVM, 'lobData.homeowners.associationName_TWIA.value.code') : _.get(submissionVM, 'baseData.associationName_TWIA.value.code');
    const ceUserName = _.get(submissionVM, 'bindData.registeredCEUsername_TWIA.value');
    const autoPayEnabled = _.get(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value');
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'CoverageSummaryPage');
        }
    }, [isComponentValid, onValidate]);
    
    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const getPCConstants = useCallback(async () => {
        const constants = await AddressStandardizationService.getPCPortalConstants(authHeader);
        if (constants.addressStandardizationDisabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }
        setPCConstants(constants);
    }, []);
    
    const setDisablity = useCallback((value) => {
        if (isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal))
        }
    }, [updateDisablity]);

    const resetElectronicPaymentData = useCallback(() => {
        const epayData = _.get(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA');

        if (epayData && epayData.aspects && !epayData.aspects.subtreeValid) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', null);
            updateWizardData(submissionVM);
        }
    }, [submissionVM, updateWizardData]);

    const onNext = useCallback(async () => {
        if (invalidComponent.length > 0) {
            setShowErrors(true)
            return false;
        }
        setShowErrors(false);
        try {
            _.set(submissionVM.value, 'bindData.isAutoPayEnabled_TWIA', false);
            _.set(submissionVM.value, 'bindData.contactEmail',submissionVM.value.baseData.accountHolder.emailAddress1);
            resetElectronicPaymentData();
            if (isRenewal) {
                submissionVM.value = await RenewalService.updateQuotedRenewal(
                    [submissionVM.value],
                    authHeader
                )
            } else if(isPolicyChange){
                submissionVM.value = await GatewayEndorsementService.saveQuotedEndorsementWithPaymentData_TWIA(
                    submissionVM.value,
                    authHeader
                );
            }
            else {
                submissionVM.value = await LoadSaveService.updateQuotedSubmission(
                    submissionVM.value,
                    authHeader
                );
            }
        updateWizardData(submissionVM);
        setIsAddressEdited(false);
            return submissionVM;
        } catch (error) {
            console.log(error)
            ErrorPopupUtil.showSaveErrorPopup(showAlert, true);
            return false;
        }
    }, [invalidComponent, submissionVM, resetElectronicPaymentData, isRenewal, 
        updateWizardData, authHeader, LoadSaveService, showAlert]);

    const updateSubmissionVM = useCallback((value) => {
        setAccountHolderVM(value);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);
    
    // DE15699
    const updatePolicyAddressVM = useCallback((value) => {
      //  _.set(submissionVM, 'baseData.accountHolder.primaryAddress', value);
        _.set(submissionVM, 'baseData.policyAddress.value', value);
        submissionVM.baseData.policyContactDetails_TWIA.children[0].primaryAddress = value;
        setDisablity(value);
        if(value.isValidated_Ext === true || value.isOverridden_Ext === true) {
            setIsAddressEdited(false);
        }
        updateWizardData(submissionVM);
    }, [setDisablity, submissionVM, updateWizardData]);
    
    // const quotePrintDocument = useCallback(async () => {
    //     setIsPrinting(true);
    //     await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, translator, authHeader, setIsPrinting);

    // }, [authHeader, showAlert, showConfirm, submissionVM, translator])

    const quotePrintDocument = useCallback(() => {
        const {getPublicID, getPath, getQuoteStatus} = PrintDocumentUtils(submissionVM);
        setIsPrinting(true);
        
        const publicID = getPublicID();
        const docPath = getPath();
        const quoteStatus = getQuoteStatus();       
        const componentProps = { submissionVM, setIsPrinting, isOpen: true, onResolve, onAfterClose, docPath, quoteStatus};       
        if (quoteStatus === 'Quoted' || quoteStatus === 'Submitted_Ext' || quoteStatus === 'Renewing') {
            CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then(() => {
                showModal(<PrintDocumentConfirmationPopup {...componentProps} />);
            });
        }  else {
            showModal(<PrintDocumentErrorPopup {...componentProps} />);
        }
    }, [authHeader, onAfterClose, onResolve, showModal, submissionVM])

    const handleAddressEditing = useCallback((val) => {
        setIsAddressEdited(val);
    });
    
    useEffect(() => {
        getPCConstants();
        setAccountHolderVM(submissionVM.baseData.accountHolder);
       // setAddressVM(submissionVM.baseData.accountHolder.primaryAddress);
        setAddressVMPolicy(submissionVM.baseData.policyAddress);
        if (submissionVM.baseData.policyAddress?.isOverridden_Ext?.value
            && !submissionVM.baseData.policyAddress?.isOverriddenInternally_Ext?.value) {
            StandardAddressValidationUtil.setNotValidated(submissionVM.baseData.policyAddress.value);
            setIsAddressEdited(true);  //DE18415
        }
    }, []);

    const generateOverrides = useCallback(() => {
        const offerings = _.get(submissionVM, 'lobData.homeowners.offerings.value');
        const overrides = offerings.map((_section, index) => ({
            [`offeringDetails${index}`]: {
                submissionVM,
                isCoverageSummaryScreen : true
            },
        }));

        return Object.assign({}, ...overrides);
    }, [submissionVM]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        emailAddressComponent: {
            accountHolderVM, updateSubmissionVM, authHeader, showErrors, findInvalidComponent, onValidate, ceUserName, autoPayEnabled,
            companyType : selectedUWCompany, setValidatingEmail
        },
        // DE15699
        mailingAddressComponent: {
            addressVM:addressVMPolicy,updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate, 
            companyType: selectedUWCompany,
            pcConstants,
            isStandardizationDisabled,
            onAddressEdit: handleAddressEditing,
            xPortal
        },
        phoneNumberComponent: {
            accountHolderVM, updateSubmissionVM, isPerson, showErrors, findInvalidComponent, onValidate
        },
        totalPremium: {
            value: {
                amount: _.get(submissionVM, 'quoteData.offeredQuotes.value[0].premium.total.amount'),
                currency: "USD"
            }
        },
        propertyAddress: {
            value: _.get(submissionVM, 'lobData.homeowners.coverables.yourHome.displayLocationAddressDTO_TWIA.displayName.value')?.split(":")[1]
        },
        PolicyDiffComponent:{
            value: jobID,
        },
        editIcon: {
            disabled: ( isButtonDisabled || isAddressEdited ) || invalidComponent.length > 0
        },
        quotePagePrint: {
            visible : !isPrinting
        },
        cLoader: {
            visible: isPrinting
        },
        ...generateOverrides(),
    };

    const resolvers = {
        resolveComponentMap: {
			phoneComponent: TWIAPhoneComponent,
            emailComponent: TWIAEmailComponent,
            addressComponent: TWIAAddressComponent,
            PolicyDiffComponent,
            customLoader: CustomLoader
			},
        resolveCallbackMap: {
            quotePrintDocument
        },
        resolveClassNameMap: { wizardStyles, styles },
    };

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
            disableNext={isButtonDisabled || isAddressEdited || validatingEmail}
            disablePrevious={validatingEmail}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    showErrors={showErrors}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </Loader>
        </WizardPage>
    );
}

TWIACoverageSummaryPage.propTypes = wizardProps;
export default TWIACoverageSummaryPage;
